import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
let HighlightPipe = class HighlightPipe {
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, searchTerm) {
        if (!searchTerm) {
            return value;
        }
        const re = new RegExp(searchTerm, "gi");
        const match = value.match(re);
        if (!match) {
            return value;
        }
        const replacedValue = value.replace(re, `<mark> ${match[0]} </mark>`);
        return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
    }
    static ctorParameters = () => [
        { type: DomSanitizer }
    ];
};
HighlightPipe = __decorate([
    Pipe({
        standalone: false,
        name: "highlight"
    })
], HighlightPipe);
export { HighlightPipe };
